// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "js/" + "about" + "." + "2496eff0" + ".js"; };